import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {recurringVoucherActions} from "./recurringVoucherSlice";
import {recurringVoucherApi} from "~/api";

function* fetchRecurringVoucherList(action) {
	try {
		const response = yield call(recurringVoucherApi.gets, action.payload);
		yield put(recurringVoucherActions.fetchDataSuccess(response))
	}
	catch (error) {
		console.log('Failed to fetch recurring voucher list', error);
		yield put(recurringVoucherActions.fetchDataFailed(error.message));
	}
}

function* handleSearchDebounce(action) {
	yield put(recurringVoucherActions.setFilter(action.payload));
}

export default function* recurringVoucherSaga() {
	yield takeLatest(recurringVoucherActions.fetchData.type, fetchRecurringVoucherList);
	yield debounce(500, recurringVoucherActions.setFilterWithDebounce.type, handleSearchDebounce)
}
